import { render } from "./ConfigurationInfoExplanation.vue?vue&type=template&id=4d7d80e1&scoped=true"
import script from "./ConfigurationInfoExplanation.vue?vue&type=script&lang=js"
export * from "./ConfigurationInfoExplanation.vue?vue&type=script&lang=js"

import "./ConfigurationInfoExplanation.vue?vue&type=style&index=0&id=4d7d80e1&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7d80e1"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
